// Contact.jsx
import React, { useState } from "react";
import Layout from "../components/layout";
import { submitForm } from "../service/submitform";

const offices = [
  {
    title: "Head Office",
    address: "20, Collyer Quay, #18-01, Singapore 049319.",
    email: "info@trescorp.biz",
    phone: "+65 6532 5055",
    hours: "Mon-Fri 9:00 AM - 6:00 PM",
  },
  {
    title: "Oman Office",
    address:
      "Office 1991 Building Office No. 321, 3rd Floor Way No 4560 South Al Khuwair Muscat, Sultanate of Oman",
    email: "info@trescorp.biz",
    phone: "+968 24699904",
    hours: "Sun-Thu 9:00 AM - 6:00 PM",
  },
  {
    title: "Oman Office (LNG)",
    address:
      "Excellence Office Building Complex No. 225 Building No. 1/564 Way No. 5508 , 113 Bousher Muscat, Sultanate of Oman",
    email: "info@trescorp.biz",
    phone: "+968 24699904",
    hours: "Sun-Thu 9:00 AM - 6:00 PM",
  },
  {
    title: "UAE Office",
    address: "OneJLT Jumeirah Lake Towers, Dubai, UAE",
    email: "info@trescorp.biz",
    phone: "+971 543551528",
    hours: "Mon-Fri 9:00 AM - 6:00 PM",
  },
];

const OfficeCard = ({ office }) => (
  <div
    className="flex flex-col w-full bg-white p-6 rounded-lg shadow-lg transition-all duration-300 hover:scale-105 hover:bg-gray-700 hover:text-white"
    style={{ minHeight: "300px" }}
  >
    <h2 className="text-2xl font-bold mb-6 text-center flex items-center justify-center min-h-[60px] transition-colors duration-300 hover:text-yellow-500">
      {office.title}
    </h2>

    <p className="text-sm leading-relaxed flex-1">{office.address}</p>

    <div className="mt-4 space-y-2 text-sm">
      <p className="flex items-center gap-2">
        <i className="fas fa-envelope" aria-label="email"></i>
        <span>Email:</span>
        <a href={`mailto:${office.email}`} className="text-blue-600 underline hover:text-blue-800">
          {office.email}
        </a>
      </p>

      <p className="flex items-center gap-2">
        <i className="fas fa-phone" aria-label="phone"></i>
        <span>Phone:</span>
        <a
          href={`tel:${office.phone.replace(/\s/g, "")}`}
          className="text-blue-600 underline hover:text-blue-800"
        >
          {office.phone}
        </a>
      </p>

      <p className="flex items-center gap-2">
        <i className="fas fa-clock" aria-label="working hours"></i>
        <span>Working Hours:</span> {office.hours}
      </p>
    </div>
  </div>
);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitForm(formData);
    setFormData({ name: "", email: "", message: "", phone: "" });
  };

  return (
    <Layout>
      <main className="overflow-hidden">
        {/* Hero */}
        <section
          className="relative min-h-[300px] flex items-center justify-center bg-cover bg-center"
          style={{ backgroundImage: "url('../img/2968.jpg')" }}
        >
          <div className="absolute inset-0 bg-gray-800 opacity-70"></div>
          <div className="relative z-10 text-center">
            <h1 className="text-white font-bold text-4xl md:text-6xl lg:text-7xl transition-all duration-300">
              Contact Us
            </h1>
          </div>
        </section>

        {/* Office Cards */}
        <section className="container mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 justify-center">
            {offices.map((office, idx) => (
              <OfficeCard key={idx} office={office} />
            ))}
          </div>
        </section>

        {/* Google Map */}
        <div className="px-4 md:px-0">
          <iframe
            title="Trescorp map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15955.262993288052!2d103.8527292!3d1.2844818!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190932680f41%3A0x50da132f16dc7865!2sTrescorp%20Alliance%20Pte%20Ltd!5e0!3m2!1sen!2sin!4v1720613804167!5m2!1sen!2sin"
            width="100%"
            height="450"
            className="border-0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Contact Form */}
        <section className="container mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <h2 className="text-center text-2xl font-bold mb-8">Contact Us</h2>
          <form onSubmit={handleSubmit} className="max-w-lg mx-auto space-y-6">
            {[
              { label: "Name", name: "name", type: "text" },
              { label: "Phone No.", name: "phone", type: "text" },
              { label: "Email", name: "email", type: "email" },
            ].map((field) => (
              <div key={field.name}>
                <label htmlFor={field.name} className="block text-sm font-medium text-gray-700">
                  {field.label}
                </label>
                <input
                  type={field.type}
                  id={field.name}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
            ))}

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="inline-flex items-center px-6 py-3 font-bold text-white bg-indigo-600 rounded-full hover:bg-indigo-700 transition"
              >
                Send Message
              </button>
            </div>
          </form>
        </section>
      </main>
    </Layout>
  );
};

export default Contact;
